import { render, staticRenderFns } from "./SubscribeMarketplace.vue?vue&type=template&id=1da1729a&scoped=true&"
import script from "./SubscribeMarketplace.vue?vue&type=script&lang=ts&"
export * from "./SubscribeMarketplace.vue?vue&type=script&lang=ts&"
import style0 from "./SubscribeMarketplace.vue?vue&type=style&index=0&id=1da1729a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1729a",
  null
  
)

export default component.exports